module.exports = "<div class=\"container\">\r\n  <h4 class=\"text-primary\">Report Processing</h4>\r\n  <div class=\"well padding\" >\r\n    <div>\r\n      <p>This report is currently in progress and will be available as soon as processing is complete.</p>\r\n      <a (click)=\"routingService.routeToDashboard()\">\r\n        <div class=\"btn btn-primary\">\r\n          Home\r\n        </div>\r\n      </a>\r\n    </div>\r\n  </div>\r\n</div>\r\n    "


//////////////////
// WEBPACK FOOTER
// ./src/app/report/components/status/report-status.component.html
// module id = ./src/app/report/components/status/report-status.component.html
// module chunks = main